import type { StyledComponent } from "@emotion/styled";
import { Fab, type FabProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const IconFab: StyledComponent<FabProps> = styled(Fab)(({ color }) => ({
  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.14), 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.2)",
  width: "25px",
  height: "25px",
  minHeight: "25px",
  background: `${color ? "" : "white"}`,
}));
